import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WorkOS } from '../_models/workOS.model';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { environment } from 'src/environments/environment';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken } from '../../auth/_selectors/auth.selectors';
import { CompanyModel } from '../_models/company.model';

@Injectable({ providedIn: 'root' })
export class WorkOSService {
  private authToken;

  constructor(
    private httpClient: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
  }

  createWorkOS(_workOS: WorkOS) {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.httpClient.post<WorkOS>(environment.USER_BASE + '/admin/workos', _workOS, {
      headers: httpHeaders,
      observe: 'response',
    });
  }

  updateWorkOS(_workOS: WorkOS): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const id = _workOS.id;
    return this.httpClient.put(environment.USER_BASE + '/admin/workos/' + id, _workOS, {
      headers: httpHeaders,
    });
  }

  findWorkOSs(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const pageSize = queryParams.pageSize;
    const pageIndex = queryParams.pageNumber;
    const searchData = queryParams.filter.searchData;
    const sortField = queryParams.sortField;
    const sortOrder = queryParams.sortOrder;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const params = new HttpParams({
      fromString:
        'page=' +
        pageIndex +
        '&size=' +
        pageSize +
        '&search_term=' +
        searchData +
        '&sort=' +
        sortField +
        ',' +
        sortOrder,
    });
    return this.httpClient.get<QueryResultsModel>(environment.USER_BASE + '/admin/workos', {
      headers,
      params,
    });
  }

  getCompanies(): Observable<CompanyModel[]> {
    const url = environment.USER_BASE + '/admin/workos/companies/without-connection';
    return this.httpClient.get<any>(url);
  }
}
